<div class="login-box login-box{{showTwoFactorFields || showQueryTwoFactorMailFields ? '-two-factor' : '-default'}}">
	<form [formGroup]="loginForm" (submit)="onLoginXena(loginForm)">
		<div class="login-logos-wrapper">
			<div class="login-logo argus-logo">
				<svg icon type="argus-logo"></svg>
			</div>
			<div class="login-logos">
				<div class="login-logo xena-logo">
					<svg icon type="xena-logo"></svg>
				</div>
				<div class="login-logo quadra-logo">
					<svg icon type="quadra-logo"></svg>
				</div>
				<div class="login-logo urania-logo">
					<svg icon type="urania-logo"></svg>
				</div>
				<div class="login-logo neo-logo">
					<svg icon type="neo-logo"></svg>
				</div>
			</div>
		</div>

		<div class="login-box-content">
			<div class="login-box-content__form">
				<div class="login-box-header" [ngClass]="{'mb-0': isLangOption}">
					<p class="login-box-header-title" i18n="Please login|Login Form@@LoginFormWelcomeMessage">Loggen Sie
						sich ein</p>
					<div class="login-box-header-language" (click)="switchLanguage()" [class.active]="isLangOption">
						<span class="login-page-text upperCase">{{country}}</span>
						<svg class="globe-svg" width="32" height="32" viewBox="0 0 32 32">
							<title>language</title>
							<path fill="currentColor"
								d="M21.813 18.688h4.5c0.188-0.875 0.375-1.75 0.375-2.688s-0.188-1.813-0.375-2.688h-4.5c0.125 0.875 0.188 1.75 0.188 2.688s-0.063 1.813-0.188 2.688zM19.438 26.063c2.438-0.813 4.563-2.563 5.813-4.75h-3.938c-0.438 1.688-1.063 3.25-1.875 4.75zM19.125 18.688c0.125-0.875 0.188-1.75 0.188-2.688s-0.063-1.813-0.188-2.688h-6.25c-0.125 0.875-0.188 1.75-0.188 2.688s0.063 1.813 0.188 2.688h6.25zM16 26.625c1.125-1.625 2-3.375 2.563-5.313h-5.125c0.563 1.938 1.438 3.688 2.563 5.313zM10.688 10.688c0.438-1.688 1.063-3.25 1.875-4.75-2.438 0.813-4.563 2.563-5.813 4.75h3.938zM6.75 21.313c1.25 2.188 3.375 3.938 5.813 4.75-0.813-1.5-1.438-3.063-1.875-4.75h-3.938zM5.688 18.688h4.5c-0.125-0.875-0.188-1.75-0.188-2.688s0.063-1.813 0.188-2.688h-4.5c-0.188 0.875-0.375 1.75-0.375 2.688s0.188 1.813 0.375 2.688zM16 5.375c-1.125 1.625-2 3.375-2.563 5.313h5.125c-0.563-1.938-1.438-3.688-2.563-5.313zM25.25 10.688c-1.25-2.188-3.375-3.938-5.813-4.75 0.813 1.5 1.438 3.063 1.875 4.75h3.938zM16 2.688c7.375 0 13.313 5.938 13.313 13.313s-5.938 13.313-13.313 13.313-13.313-5.938-13.313-13.313 5.938-13.313 13.313-13.313z">
							</path>
						</svg>
					</div>
				</div>

				<ng-container *ngIf="!isLangOption">
					<div class="l-grid">
						<div class="l-grid-cell">
							<gosuite-input formControlName="userName" type="text" placeholder="Benutzername"
								i18n-placeholder="Username|Login form@@LoginFormUsername" [required]="true"
								[autofocus]="true"></gosuite-input>
						</div>
					</div>
					<div class="l-grid">
						<div class="l-grid-cell">
							<gosuite-input formControlName="password" type="password" placeholder="Passwort"
								i18n-placeholder="Password|Login form@@LoginFormPassword"
								[required]="true"></gosuite-input>
						</div>
					</div>
				</ng-container>

				<div class="l-grid" *ngIf="isLangOption">
					<div class="l-grid-cell l-grid-cell-1-2 flag-row" *ngFor="let flag of flags"
						(click)="chooseLanguage(flag.languageCode)">
						<div class="flag-wrapper" [class.active]="flag.languageCode === country">
							<img src="/assets/images/blank.gif" [ngClass]="'flag flag-' + flag.country">
							<span class="flag-language-text">{{flag.language}}</span>
						</div>
					</div>
				</div>
			</div>

			<div class="login-box-content__two-factor-fields">
				<ng-container *ngIf="showTwoFactorFields">
					<div class="l-grid">
						<div class="l-grid-cell two-factor-info-text">
							<p>
								<strong
									i18n="Two Factor Auth|Login Form@@TwoFactorHeadline">Zwei-Faktor-Authentifizierung</strong><br />
								<span i18n="Two Factor Info Text|Login Form@@TwoFactorInfo">Aus Sicherheitsgründen ist
									die Anmeldung nur noch mit einem zweiten Faktor möglich. Bitte geben Sie den Code
									ein, der an die dafür vorgesehene E-Mail-Adresse gesendet wurde, und klicken Sie auf
									"Anmelden".</span>
							</p>
						</div>
					</div>

					<div class="l-grid">
						<div class="l-grid-cell">
							<gosuite-input formControlName="two_factor_code" type="text" placeholder=""
								[required]="true"></gosuite-input>
						</div>
					</div>

					<div class="l-grid">
						<div class="l-grid-cell two-factor-remember-me">
							<checkbox formControlName="two_factor_remember_me"
								label="Auf diesem Gerät für 28 Tage merken"
								i18n-label="Remember me for 28 days|Login Form@@RememberMeTwoFactor" type="checkbox">
							</checkbox>
							<svg icon type="info" gosuite-popover gosuitePopoverPlacement="right"
								[gosuitePopoverOnHover]="true" [gosuitePopoverContent]="rememberMeInfo"></svg>
						</div>
						<gosuite-popover-content #rememberMeInfo>
							<p class="two-factor-remember-me-popover-text"
								i18n="Remember me two factor description|Login Form@@RememberMeTwoFactorDescription">
								Wird die Checkbox angehakt, entfällt die Eingabe des Zwei-Faktor-Codes, an diesem Gerät
								und Browser, für die nächsten 7 Kalendertage.
							</p>
						</gosuite-popover-content>
					</div>
				</ng-container>

				<ng-container *ngIf="showQueryTwoFactorMailFields">
					<div class="l-grid">
						<div class="l-grid-cell two-factor-info-text">
							<p>
								<strong
									i18n="Two Factor Auth|Login Form@@TwoFactorHeadline">Zwei-Faktor-Authentifizierung</strong><br />
								<span
									i18n="Two Factor Email required info text|Login Form@@TwoFactorMailRequiredInfoText">Für
									diesen Benutzer liegt uns keine E-Mail-Adresse für den Versand des zweiten Faktors
									vor. Bitte geben Sie eine individuelle E-Mail-Adresse an, auf die nur Sie Zugriff
									haben, damit wir Ihnen den Authentifizierungscode für eine sichere Anmeldung
									zusenden können.</span>
							</p>
						</div>
					</div>

					<div class="l-grid">
						<div class="l-grid-cell">
							<gosuite-input formControlName="two_factor_mail" type="text" placeholder=""
								[required]="true"></gosuite-input>
						</div>
					</div>

					<div class="l-grid">
						<div class="l-grid-cell two-factor-opt-in">
							<checkbox formControlName="mail_opt_in"
								label="Hiermit stimme ich dem Versand wichtiger technischer Informationen und Supportangelegenheiten durch Schmetterling International GmbH & Co. KG an meine geschäftliche E-Mail-Adresse zu."
								i18n-label="Opt In two factor mails|Login Form@@OptInTwoFactorMails" type="checkbox">
							</checkbox>
						</div>
					</div>
				</ng-container>
			</div>

			<div class="login-box-content__error" *ngIf="errorMessage">
				<p class="alert-error" *ngIf="errorMessage">{{errorMessage}}</p>
			</div>

			<div class="l-grid login-box-content__submit">
				<div class="l-grid-cell">
					<gosuite-button *ngIf="!isLangOption" type="submit" [label]="'LOGIN'"
						i18n-label="Login Button|Login form@@LoginFormLoginButton"></gosuite-button>
				</div>
			</div>
		</div>
	</form>

</div>



// WEBPACK FOOTER //
// ./src/app/login/login.component.html